/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ when: NonNullable<unknown> }} Search_Preview_ConversationInputs */

const en_us2_search_preview_conversation = /** @type {(inputs: Search_Preview_ConversationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conversation with your trainer · ${i?.when}`)
};

const pt_br2_search_preview_conversation = /** @type {(inputs: Search_Preview_ConversationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conversa com o seu personal · ${i?.when}`)
};

const es_419_search_preview_conversation = /** @type {(inputs: Search_Preview_ConversationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conversación con tu entrenador · ${i?.when}`)
};

const pt_pt2_search_preview_conversation = /** @type {(inputs: Search_Preview_ConversationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conversa com o teu treinador · ${i?.when}`)
};

const fr_fr2_search_preview_conversation = /** @type {(inputs: Search_Preview_ConversationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conversation avec ton coach · ${i?.when}`)
};

const de_de2_search_preview_conversation = /** @type {(inputs: Search_Preview_ConversationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unterhaltung mit deinem Coach · ${i?.when}`)
};

const it_it2_search_preview_conversation = /** @type {(inputs: Search_Preview_ConversationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conversazione con il tuo coach · ${i?.when}`)
};

/**
* | output |
* | --- |
* | "Conversation with your trainer · {when}" |
*
* @param {Search_Preview_ConversationInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_preview_conversation = /** @type {((inputs: Search_Preview_ConversationInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Preview_ConversationInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_preview_conversation(inputs)
	if (locale === "es-419") return es_419_search_preview_conversation(inputs)
	if (locale === "pt-PT") return pt_pt2_search_preview_conversation(inputs)
	if (locale === "fr-FR") return fr_fr2_search_preview_conversation(inputs)
	if (locale === "de-DE") return de_de2_search_preview_conversation(inputs)
	if (locale === "it-IT") return it_it2_search_preview_conversation(inputs)
	return en_us2_search_preview_conversation(inputs)
});
export { search_preview_conversation as "search.preview_conversation" }